import React, { memo, useCallback } from 'react';
import { DynamicListFilter, FilterProps } from '@dfl/mui-admin-layout';
import { useSearchParams } from 'react-router-dom';

interface StateAddressFilterProps extends FilterProps {
  countryKey?: string;
  cityKey?: string;
  justUseFor?: string;
  multiple?: boolean;
}

const StateAddressFilter = ({
  filter,
  value,
  title,
  countryKey,
  cityKey,
  justUseFor,
  multiple = false,
}: StateAddressFilterProps) => {
  const [searchParams, setSearchParams] = useSearchParams();

  const countryCode = searchParams.get(countryKey || 'country') || '';

  const fetchFunc = useCallback(
    async (params?: any) => {
      params = { ...params, country: justUseFor || countryCode };
      return await filter?.fetchFunc?.(params);
    },
    [countryCode, filter, justUseFor],
  );

  const handleStateChange = useCallback(
    (e: any) => {
      const newSearchParams = new URLSearchParams(searchParams.toString());
      // Limpiar ciudad al cambiar estado
      if (cityKey && searchParams.get(cityKey)) {
        newSearchParams.delete(cityKey);
      }

      if (multiple) {
        newSearchParams.delete(filter.key);
        const selected: string[] = Array.isArray(e) ? e : [e].filter(Boolean);
        if (selected.length > 0) {
          newSearchParams.set(filter.key, selected.join(','));
        }
      } else {
        if (e?.[0]) {
          newSearchParams.set(filter.key, e[0]);
        } else {
          newSearchParams.delete(filter.key);
        }
      }

      setSearchParams(newSearchParams);
    },
    [searchParams, cityKey, setSearchParams, filter.key, multiple],
  );

  // Parsear el valor actual desde la URL para múltiple
  const parsedValue: string[] = multiple
    ? (searchParams.get(filter.key) || '').split(',').filter(Boolean)
    : Array.isArray(value)
      ? value
      : value
        ? [value]
        : [];

  return (
    <DynamicListFilter
      key={`${filter.key}-${justUseFor || countryCode}-state-${value as string}`}
      // @ts-ignore
      filter={{
        ...filter,
        fetchFunc,
        queryKey: `${filter.key}-${justUseFor || countryCode}-state-${value as string}`,
        multiple,
      }}
      value={!justUseFor && !countryCode ? '' : parsedValue || []}
      title={title}
      onChange={handleStateChange}
    />
  );
};

export default memo(StateAddressFilter);
